import React from 'react'

/** Class to put on OTP cells (via `classInput`) so they pop when a digit lands. */
export const OTP_CELL_CLASS = 'lc-otp-cell'

/*
 * React keeps the `value` attribute of controlled inputs in sync, so `:not([value=''])`
 * matches exactly when a cell holds a digit. The animation (re)starts each time the
 * selector begins to match, which gives a pop on fill and nothing on clear.
 * Kept behind prefers-reduced-motion: no-preference so it never moves for people who opted out.
 */
const CSS = `@media (prefers-reduced-motion: no-preference) {
  @keyframes lc-otp-pop { from { transform: scale(0.92); } 60% { transform: scale(1.04); } to { transform: scale(1); } }
  .${OTP_CELL_CLASS}:not([value='']) { animation: lc-otp-pop 220ms var(--ease-out-strong) both; }
}`

/** Mount once per page that renders an OTP field. */
const OtpPopStyle = () => <style dangerouslySetInnerHTML={{ __html: CSS }} />

export default OtpPopStyle
